module.exports = __webpack_public_path__ + "static/auto_3-e47d4a6d05c6a1798470c8c8ab970746.jpg";